import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { useRef, useCallback, useEffect } from 'react';
import { DO_NOT_DISPLAY_THREAD } from 'copilot-toolkit/constants/PromptThread';
const PreviewButton = ({
  actionFn,
  actionButtonObj,
  streamingState,
  messageQuery
}) => {
  var _actionButtonObj$payl;
  const wasStreamingRef = useRef(false);
  const wasSentRef = useRef(false);
  const payloadJsonStringMaybe = actionButtonObj === null || actionButtonObj === void 0 || (_actionButtonObj$payl = actionButtonObj.payload) === null || _actionButtonObj$payl === void 0 ? void 0 : _actionButtonObj$payl.payloadJson;
  let payloadJsonObj;
  try {
    payloadJsonObj = payloadJsonStringMaybe ? JSON.parse(payloadJsonStringMaybe) : undefined;
  } catch (error) {
    consoleIfNotProd.error(`Error parsing payloadJsonString ${error}, payloadJsonStringMaybe -> ${payloadJsonStringMaybe}`);
  }
  const handleOnClick = useCallback(() => {
    if (!payloadJsonObj || !actionButtonObj) return;
    return actionFn({
      actionType: 'preview_actions',
      infoToPassToApp: {
        toolOutput: payloadJsonObj.toolOutput,
        messageQuery
      },
      userThread: DO_NOT_DISPLAY_THREAD
    });
  }, [payloadJsonObj, actionButtonObj, actionFn, messageQuery]);

  // Automatically triggers the preview action once streaming completes
  // This ensures the most recent generated actions get previewed without requiring manual interaction
  useEffect(() => {
    if (streamingState === 'streaming') {
      wasStreamingRef.current = true;
    }
    if (wasSentRef.current || !wasStreamingRef.current) {
      return;
    }
    wasSentRef.current = true;
    handleOnClick();
  }, [streamingState, handleOnClick]);

  // The preview button is not rendered in the UI, it is used to trigger
  // the preview action only via the useEffect hook
  return null;
};
export default PreviewButton;